import { render, staticRenderFns } from "./ViewersList.vue?vue&type=template&id=3989aa8c&scoped=true&"
import script from "./ViewersList.vue?vue&type=script&lang=ts&"
export * from "./ViewersList.vue?vue&type=script&lang=ts&"
import style0 from "./ViewersList.vue?vue&type=style&index=0&id=3989aa8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3989aa8c",
  null
  
)

export default component.exports